import React, { useState } from "react";
import { Step, StepTitle, Stepper } from "react-progress-stepper";
import { useTranslation } from "react-i18next";
import EstimationNotificationModal from "./EstimationNotificationModal";
import { Badge } from "react-bootstrap";
import EstimationRequest from "../../services/estimationRequest";
import { downloadFile, formatAmount } from "../../util/common";
import { estimationStatus } from "../../util/constants";
import { useEffect } from "react";
import { getFormattedCarNumberPlate } from "../../util/carOptionsUtils";
import { currentLanguage } from "../../util/common";
import { Icon, Button, RiyalIcon } from "../shared";
import { useAppNavigation } from "../../hooks";

const EstimateProgress = ({ estimations, getEstimations, estimationsFetched, estimationId }) => {
  const { t } = useTranslation();
  const { localeRoutes, toUrlWithData } = useAppNavigation();

  const language = currentLanguage();

  const [selectedEstimation, setSelectedEstimation] = useState({});
  const [notificationModalViewer, setNotificationModalViewer] = useState(false);

  const createMasterStep = (masterStatus) => {
    const status = estimationStatus[masterStatus];

    const step1Props = { customContent: undefined };
    if (status === 0) {
      step1Props.customContent = () => <div className="current-step" />;
    }

    const step2Props = { customContent: undefined };
    if (status === 1) {
      step2Props.customContent = () => <div className="current-step" />;
    }

    return (
      <>
        <Stepper step={status} numbered={false}>
          <Step {...step1Props}>
            <StepTitle>{t("track.estimateRequested")}</StepTitle>
          </Step>
          <Step {...step2Props}>
            <StepTitle>{t("track.estimationInProgress")}</StepTitle>
          </Step>
          <Step customContent={() => <Icon iconName="medal" />}>
            <StepTitle>
              {t(
                masterStatus === "Estimation Closed"
                  ? "track.estimateClosed"
                  : "track.estimateCompleted"
              )}
            </StepTitle>
          </Step>
        </Stepper>
      </>
    );
  };

  useEffect(() => {
    openEstimationById();
  }, [estimationsFetched]);

  const openEstimationById = () => {
    if (!estimationId) return;

    const filteredEstimation = estimations?.filter((est) => est?._id === estimationId);
    if (filteredEstimation.length) viewComments(filteredEstimation[0]);
  };

  const viewComments = async (est) => {
    try {
      setSelectedEstimation(est);
      setNotificationModalViewer(true);
      if (getUnseenComments(est?.comments)) {
        await EstimationRequest.updateComments(est?._id, est?.comments[0]?.user);
        getEstimations();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const closeNotificationModal = () => setNotificationModalViewer(false);

  const navigateToScheduleAppoinment = (est) => {
    toUrlWithData(localeRoutes.appointment[language], {
      estimationID: est?._id,
      service: { id: "63ad76073215eb77f51296bb" }
    });
  };

  const getUnseenComments = (comments) => comments?.filter((comment) => !comment?.seen).length || 0;

  // const handleViewReasonModal = (est) => {
  //   setSelectedEstimation(est);
  //   setReasonModalViewer(true);
  // };

  // const closeReasonModal = () => {
  //   setReasonModalViewer(false);
  //   setSelectedEstimation({});
  // };

  return (
    <>
      {estimations.map((est, i) => {
        let parentClass = "row request-estimate-body estimate-head ";
        parentClass += est?.isApproved && !est?.cancelRequest ? " estimation-approved" : "";
        parentClass += est?.isExpired ? " estimation-expired" : "";
        parentClass += est?.cancelRequest ? " estimation-canceled" : "";
        parentClass += est?.isAppointmentCreated ? " estimation-booked" : "";

        const car = est.carData[0];

        return (
          <div className={parentClass} key={i}>
            <div className="col-md-3 col-lg-3 col-xl-2 status-for">
              <h5>
                {est.otherBrand || car?.brand["value_" + language]}{" "}
                {est.otherModel || car?.product["value_" + language]}
                <br />
                {getFormattedCarNumberPlate(est.licencePlate)}
              </h5>
              {window.innerWidth <= 991 && est?.isApproved && !est?.cancelRequest && (
                <div className="estimation-data">
                  <span className="moreDetails">
                    {t("track.cost")}:{" "}
                    <span className="fw-bold">
                      <RiyalIcon /> {formatAmount(est?.cost)}
                    </span>
                  </span>
                  <a className="pdf-link">
                    <button onClick={() => downloadFile(est?.costPdf)}>
                      {t("track.downloadEstimation")}
                    </button>
                  </a>

                  {!est?.isAppointmentCreated && !est?.isExpired && (
                    <div className="estimation-btn">
                      <Button
                        type="small-roundedRight"
                        customize="m-0"
                        action={() => navigateToScheduleAppoinment(est)}>
                        {t("track.book")}
                      </Button>
                    </div>
                  )}
                </div>
              )}
              {est?.isExpired && !est?.cancelRequest && (
                <p className="expired-label">{t("track.estimationExpired")}</p>
              )}
              {/* {est?.cancelRequest && (
                  <p className="closed-label">{t("track.estimationClosed")}</p>
                )} */}
            </div>
            <div className="col-md-8 col-lg-7 col-xl-8">{createMasterStep(est?.status)}</div>
            <div className="col-md-1 col-lg-2 col-xl-2 p-0">
              <div className="notification-icon">
                <Icon iconName="bell" onClick={() => viewComments(est)} />
                <Badge className="badge-icon" bg="warning">
                  {getUnseenComments(est?.comments)}
                </Badge>
              </div>
              <div className="notification-icon read-comments">
                <button className="view-comments" onClick={() => viewComments(est)}>
                  {t("track.viewComments")}
                </button>
              </div>
              {window.innerWidth > 991 && est?.isApproved && !est?.cancelRequest && (
                <div className="estimation-data desktop">
                  <span className="moreDetails">
                    {t("track.cost")}:{" "}
                    <span className="fw-bold">
                      <RiyalIcon /> {formatAmount(est?.cost)}
                    </span>
                  </span>
                  <a className="pdf-link">
                    <button onClick={() => downloadFile(est?.costPdf)}>
                      {t("track.downloadEstimation")}
                    </button>
                  </a>

                  {!est?.isAppointmentCreated && !est?.isExpired && !est?.cancelRequest && (
                    <div className="estimation-btn">
                      <Button
                        type="small-roundedRight"
                        customize="m-0"
                        action={() => navigateToScheduleAppoinment(est)}>
                        {t("track.book")}
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}

      <EstimationNotificationModal
        show={notificationModalViewer}
        close={closeNotificationModal}
        selectedEstimation={selectedEstimation}
      />

      {/* {reasonModalViewer && (
        <EstimationReasonModal
          show={reasonModalViewer}
          close={closeReasonModal}
          selectedEstimation={selectedEstimation}
        />
      )} */}
    </>
  );
};

export default React.memo(EstimateProgress);
